module.exports = __webpack_public_path__ + "static/img/banner2.4eb0241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/banner2.jpg
// module id = 7r6Q
// module chunks = 1